// JavaScript Document
const strLink1="https://interior-arne.com/products/"
function setGoods(url,haba,depth,height,price,cloth){
this.url=url;this.haba=haba;this.depth=depth;this.height=height;this.price=price;this.cloth=cloth;
}
function searchURL(){
var habaValue=document.getElementById("haba").value;
var heightValue=document.getElementById("height").value;
var url=document.getElementById("link_url");
var flag = false; 
if(habaValue=="haba-select" && heightValue=="height-selected"){
alert("「幅・高さ」を選んでください");
return false;
}
if(habaValue=="haba-select"){
alert("「幅」を選んでください");
return false;
}
if(heightValue=="height-selected"){
alert("「高さ」を選んでください");
return false;
}
for(var i=0; i<document.frm_cava.cloth.length;i++){
     // i番目のラジオボタンがチェックされているかを判定
     if(document.frm_cava.cloth[i].checked){ 
         flag = true;    
         clothValue=document.frm_cava.cloth[i].id;
     }
}
 for(var i in goods){
  if(goods[i].height==heightValue && goods[i].haba==habaValue && goods[i].cloth==clothValue){
   return goods[i].url;
  }
 }
alert("ご希望サイズ幅"+habaValue+"cm×高さ"+heightValue+"cm"+clothValue+"生地は購入ページのご用意がございません。\nお手数をおかけしますがサイズオーダーフォームよりご注文くださいませ。");
return false;
}
function jump(){
var url=searchURL();
if(!url){
return false;
}
window.open(strLink1+url)
return false;
}
goods = new Object();
goods[0] =new setGoods("0000a41929","40","64","78","23000","ns7");
goods[1] =new setGoods("0000a41935","40","64","78","23000","sofia");
goods[2] =new setGoods("0000a41947","40","64","78","23000","modern");
goods[3] =new setGoods("0000a41950","40","64","78","25000","oct");
goods[4] =new setGoods("0000a41954","40","64","78","29000","moq");
goods[5] =new setGoods("0000a41964","40","64","78","32000","michael");
goods[6] =new setGoods("0000a41974","40","64","78","29000","leather");
goods[7] =new setGoods("0000a41979","40","64","78","29000","chappy");
goods[8] =new setGoods("0000a41980","40","64","78","29000","denim");
goods[9] =new setGoods("0000a41985","40","64","78","23000","meisai");
goods[10] =new setGoods("0000a41988","40","64","78","25000","flower");
goods[11] =new setGoods("0000a41990","40","64","78","29000","magic");
goods[12] =new setGoods("0000a41997","40","64","78","25000","illust");
goods[13] =new setGoods("0000a42002","40","64","78","25000","pattern");
goods[14] =new setGoods("0000a42008","40","64","78","35000","caleido");
goods[15] =new setGoods("0000a42021","90","64","78","40000","ns7");
goods[16] =new setGoods("0000a42027","90","64","78","40000","sofia");
goods[17] =new setGoods("0000a42039","90","64","78","40000","modern");
goods[18] =new setGoods("0000a42042","90","64","78","45000","oct");
goods[19] =new setGoods("0000a42046","90","64","78","55000","moq");
goods[20] =new setGoods("0000a42056","90","64","78","60000","michael");
goods[21] =new setGoods("0000a42066","90","64","78","55000","leather");
goods[22] =new setGoods("0000a42071","90","64","78","55000","chappy");
goods[23] =new setGoods("0000a42072","90","64","78","55000","denim");
goods[24] =new setGoods("0000a42077","90","64","78","40000","meisai");
goods[25] =new setGoods("0000a42080","90","64","78","45000","flower");
goods[26] =new setGoods("0000a42082","90","64","78","55000","magic");
goods[27] =new setGoods("0000a42089","90","64","78","45000","illust");
goods[28] =new setGoods("0000a42094","90","64","78","45000","pattern");
goods[29] =new setGoods("0000a42100","90","64","78","65000","caleido");
goods[30] =new setGoods("0000a42113","120","64","78","50000","ns7");
goods[31] =new setGoods("0000a42119","120","64","78","50000","sofia");
goods[32] =new setGoods("0000a42131","120","64","78","50000","modern");
goods[33] =new setGoods("0000a42134","120","64","78","56000","oct");
goods[34] =new setGoods("0000a42138","120","64","78","69000","moq");
goods[35] =new setGoods("0000a42148","120","64","78","76000","michael");
goods[36] =new setGoods("0000a42158","120","64","78","69000","leather");
goods[37] =new setGoods("0000a42163","120","64","78","69000","chappy");
goods[38] =new setGoods("0000a42164","120","64","78","69000","denim");
goods[39] =new setGoods("0000a42169","120","64","78","50000","meisai");
goods[40] =new setGoods("0000a42172","120","64","78","56000","flower");
goods[41] =new setGoods("0000a42174","120","64","78","69000","magic");
goods[42] =new setGoods("0000a42181","120","64","78","56000","illust");
goods[43] =new setGoods("0000a42186","120","64","78","56000","pattern");
goods[44] =new setGoods("0000a42192","120","64","78","83000","caleido");
goods[45] =new setGoods("0000a42205","160","64","78","64000","ns7");
goods[46] =new setGoods("0000a42211","160","64","78","64000","sofia");
goods[47] =new setGoods("0000a42223","160","64","78","64000","modern");
goods[48] =new setGoods("0000a42226","160","64","78","72000","oct");
goods[49] =new setGoods("0000a42230","160","64","78","90000","moq");
goods[50] =new setGoods("0000a42240","160","64","78","98000","michael");
goods[51] =new setGoods("0000a42250","160","64","78","90000","leather");
goods[52] =new setGoods("0000a42255","160","64","78","90000","chappy");
goods[53] =new setGoods("0000a42256","160","64","78","90000","denim");
goods[54] =new setGoods("0000a42261","160","64","78","64000","meisai");
goods[55] =new setGoods("0000a42264","160","64","78","72000","flower");
goods[56] =new setGoods("0000a42266","160","64","78","90000","magic");
goods[57] =new setGoods("0000a42273","160","64","78","72000","illust");
goods[58] =new setGoods("0000a42278","160","64","78","72000","pattern");
goods[59] =new setGoods("0000a42284","160","64","78","108000","caleido");
goods[60] =new setGoods("0000a42297","190","64","78","74000","ns7");
goods[61] =new setGoods("0000a42303","190","64","78","74000","sofia");
goods[62] =new setGoods("0000a42315","190","64","78","74000","modern");
goods[63] =new setGoods("0000a42318","190","64","78","85000","oct");
goods[64] =new setGoods("0000a42322","190","64","78","105000","moq");
goods[65] =new setGoods("0000a42332","190","64","78","116000","michael");
goods[66] =new setGoods("0000a42342","190","64","78","105000","leather");
goods[67] =new setGoods("0000a42347","190","64","78","105000","chappy");
goods[68] =new setGoods("0000a42348","190","64","78","105000","denim");
goods[69] =new setGoods("0000a42353","190","64","78","74000","meisai");
goods[70] =new setGoods("0000a42356","190","64","78","85000","flower");
goods[71] =new setGoods("0000a42358","190","64","78","105000","magic");
goods[72] =new setGoods("0000a42365","190","64","78","85000","illust");
goods[73] =new setGoods("0000a42370","190","64","78","85000","pattern");
goods[74] =new setGoods("0000a42376","190","64","78","127000","caleido");
goods[75] =new setGoods("0000a42389","40","64","73","23000","ns7");
goods[76] =new setGoods("0000a42395","40","64","73","23000","sofia");
goods[77] =new setGoods("0000a42407","40","64","73","23000","modern");
goods[78] =new setGoods("0000a42410","40","64","73","25000","oct");
goods[79] =new setGoods("0000a42414","40","64","73","29000","moq");
goods[80] =new setGoods("0000a42424","40","64","73","32000","michael");
goods[81] =new setGoods("0000a42434","40","64","73","29000","leather");
goods[82] =new setGoods("0000a42439","40","64","73","29000","chappy");
goods[83] =new setGoods("0000a42440","40","64","73","29000","denim");
goods[84] =new setGoods("0000a42445","40","64","73","23000","meisai");
goods[85] =new setGoods("0000a42448","40","64","73","25000","flower");
goods[86] =new setGoods("0000a42450","40","64","73","29000","magic");
goods[87] =new setGoods("0000a42457","40","64","73","25000","illust");
goods[88] =new setGoods("0000a42462","40","64","73","25000","pattern");
goods[89] =new setGoods("0000a42468","40","64","73","35000","caleido");
goods[90] =new setGoods("0000a42481","90","64","73","40000","ns7");
goods[91] =new setGoods("0000a42487","90","64","73","40000","sofia");
goods[92] =new setGoods("0000a42499","90","64","73","40000","modern");
goods[93] =new setGoods("0000a42502","90","64","73","45000","oct");
goods[94] =new setGoods("0000a42506","90","64","73","55000","moq");
goods[95] =new setGoods("0000a42516","90","64","73","60000","michael");
goods[96] =new setGoods("0000a42526","90","64","73","55000","leather");
goods[97] =new setGoods("0000a42531","90","64","73","55000","chappy");
goods[98] =new setGoods("0000a42532","90","64","73","55000","denim");
goods[99] =new setGoods("0000a42537","90","64","73","40000","meisai");
goods[100] =new setGoods("0000a42540","90","64","73","45000","flower");
goods[101] =new setGoods("0000a42542","90","64","73","55000","magic");
goods[102] =new setGoods("0000a42549","90","64","73","45000","illust");
goods[103] =new setGoods("0000a42554","90","64","73","45000","pattern");
goods[104] =new setGoods("0000a42560","90","64","73","65000","caleido");
goods[105] =new setGoods("0000a42573","120","64","73","50000","ns7");
goods[106] =new setGoods("0000a42579","120","64","73","50000","sofia");
goods[107] =new setGoods("0000a42591","120","64","73","50000","modern");
goods[108] =new setGoods("0000a42594","120","64","73","56000","oct");
goods[109] =new setGoods("0000a42598","120","64","73","69000","moq");
goods[110] =new setGoods("0000a42608","120","64","73","76000","michael");
goods[111] =new setGoods("0000a42618","120","64","73","69000","leather");
goods[112] =new setGoods("0000a42623","120","64","73","69000","chappy");
goods[113] =new setGoods("0000a42624","120","64","73","69000","denim");
goods[114] =new setGoods("0000a42629","120","64","73","50000","meisai");
goods[115] =new setGoods("0000a42632","120","64","73","56000","flower");
goods[116] =new setGoods("0000a42634","120","64","73","69000","magic");
goods[117] =new setGoods("0000a42641","120","64","73","56000","illust");
goods[118] =new setGoods("0000a42646","120","64","73","56000","pattern");
goods[119] =new setGoods("0000a42652","120","64","73","83000","caleido");
goods[120] =new setGoods("0000a42665","160","64","73","64000","ns7");
goods[121] =new setGoods("0000a42671","160","64","73","64000","sofia");
goods[122] =new setGoods("0000a42683","160","64","73","64000","modern");
goods[123] =new setGoods("0000a42686","160","64","73","72000","oct");
goods[124] =new setGoods("0000a42690","160","64","73","90000","moq");
goods[125] =new setGoods("0000a42700","160","64","73","98000","michael");
goods[126] =new setGoods("0000a42710","160","64","73","90000","leather");
goods[127] =new setGoods("0000a42715","160","64","73","90000","chappy");
goods[128] =new setGoods("0000a42716","160","64","73","90000","denim");
goods[129] =new setGoods("0000a42721","160","64","73","64000","meisai");
goods[130] =new setGoods("0000a42724","160","64","73","72000","flower");
goods[131] =new setGoods("0000a42726","160","64","73","90000","magic");
goods[132] =new setGoods("0000a42733","160","64","73","72000","illust");
goods[133] =new setGoods("0000a42738","160","64","73","72000","pattern");
goods[134] =new setGoods("0000a42744","160","64","73","108000","caleido");
goods[135] =new setGoods("0000a42757","190","64","73","74000","ns7");
goods[136] =new setGoods("0000a42763","190","64","73","74000","sofia");
goods[137] =new setGoods("0000a42775","190","64","73","74000","modern");
goods[138] =new setGoods("0000a42778","190","64","73","85000","oct");
goods[139] =new setGoods("0000a42782","190","64","73","105000","moq");
goods[140] =new setGoods("0000a42792","190","64","73","116000","michael");
goods[141] =new setGoods("0000a42802","190","64","73","105000","leather");
goods[142] =new setGoods("0000a42807","190","64","73","105000","chappy");
goods[143] =new setGoods("0000a42808","190","64","73","105000","denim");
goods[144] =new setGoods("0000a42813","190","64","73","74000","meisai");
goods[145] =new setGoods("0000a42816","190","64","73","85000","flower");
goods[146] =new setGoods("0000a42818","190","64","73","105000","magic");
goods[147] =new setGoods("0000a42825","190","64","73","85000","illust");
goods[148] =new setGoods("0000a42830","190","64","73","85000","pattern");
goods[149] =new setGoods("0000a42836","190","64","73","127000","caleido");
